"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from "react";
import { CreateWaveDatesConfig } from "@/types/waves.types";
import { ApiWaveType } from "@/generated/models/ApiWaveType";
import StartDates from "./StartDates";
import Decisions from "./Decisions";
import RollingEndDate from "./RollingEndDate";
import { adjustDatesAfterSubmissionChange, calculateEndDate, validateDateSequence } from "../services/waveDecisionService";
interface CreateWaveDatesProps {
  readonly waveType: ApiWaveType;
  readonly dates: CreateWaveDatesConfig;
  readonly setDates: (dates: CreateWaveDatesConfig) => void;
}
export default function CreateWaveDates(t0) {
  const $ = _c(51);
  const {
    waveType,
    dates,
    setDates
  } = t0;
  const [isRollingMode, setIsRollingMode] = useState(dates.isRolling);
  let t1;
  if ($[0] !== dates.isRolling) {
    t1 = {
      start: true,
      decisions: false,
      rolling: dates.isRolling
    };
    $[0] = dates.isRolling;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [expandedSections, setExpandedSections] = useState(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      start: false,
      decisions: false
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [autoCollapsedSections, setAutoCollapsedSections] = useState(t2);
  let t3;
  if ($[3] !== dates.isRolling || $[4] !== expandedSections.rolling) {
    t3 = () => {
      setIsRollingMode(dates.isRolling);
      if (dates.isRolling && !expandedSections.rolling) {
        setExpandedSections(_temp);
      }
    };
    $[3] = dates.isRolling;
    $[4] = expandedSections.rolling;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== dates.isRolling) {
    t4 = [dates.isRolling];
    $[6] = dates.isRolling;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  if ($[8] !== dates || $[9] !== setDates) {
    t5 = () => {
      const validationErrors = validateDateSequence(dates);
      if (validationErrors.length > 0) {
        console.warn("Date validation errors:", validationErrors);
      }
      if (!dates.isRolling) {
        const calculatedEndDate = calculateEndDate(dates);
        if (calculatedEndDate !== dates.endDate) {
          setDates({
            ...dates,
            endDate: calculatedEndDate
          });
        }
      }
    };
    $[8] = dates;
    $[9] = setDates;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== dates.firstDecisionTime || $[12] !== dates.isRolling || $[13] !== dates.submissionStartDate || $[14] !== dates.subsequentDecisions || $[15] !== dates.votingStartDate) {
    t6 = [dates.submissionStartDate, dates.votingStartDate, dates.firstDecisionTime, dates.subsequentDecisions, dates.isRolling];
    $[11] = dates.firstDecisionTime;
    $[12] = dates.isRolling;
    $[13] = dates.submissionStartDate;
    $[14] = dates.subsequentDecisions;
    $[15] = dates.votingStartDate;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  useEffect(t5, t6);
  let t7;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = sectionName => {
      setExpandedSections(prev_0 => ({
        ...prev_0,
        [sectionName]: !prev_0[sectionName]
      }));
    };
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const toggleSection = t7;
  let t8;
  if ($[18] !== autoCollapsedSections.start) {
    t8 = () => {
      if (!autoCollapsedSections.start) {
        setExpandedSections(_temp2);
        setAutoCollapsedSections(_temp3);
      }
    };
    $[18] = autoCollapsedSections.start;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  const handleDecisionsInteraction = t8;
  let t9;
  if ($[20] !== autoCollapsedSections.decisions) {
    t9 = () => {
      if (!autoCollapsedSections.decisions) {
        setExpandedSections(_temp4);
        setAutoCollapsedSections(_temp5);
      }
    };
    $[20] = autoCollapsedSections.decisions;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  const handleRollingInteraction = t9;
  let t10;
  if ($[22] !== dates || $[23] !== setDates) {
    t10 = newDates => {
      if (newDates.submissionStartDate !== dates.submissionStartDate) {
        const adjustedDates = adjustDatesAfterSubmissionChange(dates, newDates.submissionStartDate);
        setDates(adjustedDates);
      } else {
        setDates(newDates);
      }
    };
    $[22] = dates;
    $[23] = setDates;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  const handleDateUpdate = t10;
  let t11;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => toggleSection("start");
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== dates || $[27] !== expandedSections.start || $[28] !== handleDateUpdate || $[29] !== waveType) {
    t12 = <StartDates waveType={waveType} dates={dates} setDates={handleDateUpdate} isExpanded={expandedSections.start} setIsExpanded={t11} />;
    $[26] = dates;
    $[27] = expandedSections.start;
    $[28] = handleDateUpdate;
    $[29] = waveType;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== expandedSections.rolling) {
    t13 = isRolling => {
      setIsRollingMode(isRolling);
      if (isRolling && !expandedSections.rolling) {
        setExpandedSections(_temp6);
      }
    };
    $[31] = expandedSections.rolling;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = () => toggleSection("decisions");
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== dates || $[35] !== expandedSections.decisions || $[36] !== handleDecisionsInteraction || $[37] !== isRollingMode || $[38] !== setDates || $[39] !== t13) {
    t15 = <Decisions dates={dates} setDates={setDates} isRollingMode={isRollingMode} setIsRollingMode={t13} isExpanded={expandedSections.decisions} setIsExpanded={t14} onInteraction={handleDecisionsInteraction} />;
    $[34] = dates;
    $[35] = expandedSections.decisions;
    $[36] = handleDecisionsInteraction;
    $[37] = isRollingMode;
    $[38] = setDates;
    $[39] = t13;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  let t16;
  if ($[41] !== dates || $[42] !== expandedSections.rolling || $[43] !== handleRollingInteraction || $[44] !== isRollingMode || $[45] !== setDates) {
    t16 = dates.subsequentDecisions.length > 0 && (isRollingMode || dates.isRolling) && <RollingEndDate dates={dates} setDates={setDates} isRollingMode={isRollingMode} setIsRollingMode={isRolling_0 => {
      setIsRollingMode(isRolling_0);
      handleRollingInteraction();
    }} isExpanded={expandedSections.rolling} setIsExpanded={() => toggleSection("rolling")} />;
    $[41] = dates;
    $[42] = expandedSections.rolling;
    $[43] = handleRollingInteraction;
    $[44] = isRollingMode;
    $[45] = setDates;
    $[46] = t16;
  } else {
    t16 = $[46];
  }
  let t17;
  if ($[47] !== t12 || $[48] !== t15 || $[49] !== t16) {
    t17 = <div className="tw-space-y-4">{t12}{t15}{t16}</div>;
    $[47] = t12;
    $[48] = t15;
    $[49] = t16;
    $[50] = t17;
  } else {
    t17 = $[50];
  }
  return t17;
}
function _temp6(prev_5) {
  return {
    ...prev_5,
    rolling: true
  };
}
function _temp5(prev_4) {
  return {
    ...prev_4,
    decisions: true
  };
}
function _temp4(prev_3) {
  return {
    ...prev_3,
    decisions: false
  };
}
function _temp3(prev_2) {
  return {
    ...prev_2,
    start: true
  };
}
function _temp2(prev_1) {
  return {
    ...prev_1,
    start: false
  };
}
function _temp(prev) {
  return {
    ...prev,
    rolling: true
  };
}